import { Component, Input, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WorkflowService } from "../../services/workflow.service";

@Component({
  selector: "app-upload-wf-history",
  templateUrl: "./upload-wf-history.component.html",
  styleUrls: ["./upload-wf-history.component.scss"],
})
export class UploadWfHistoryComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public workflowService: WorkflowService
  ) {}

  history: Array<any>;

  ColumnsFile: string[] = ["moment", "details", "authorUserName", "comments"];

  // Init
  ngOnInit() {
    this.loadHistory();
  }

  loadHistory() {
    this.workflowService.getHistory(this.data.workflowId).subscribe((h) => {
      this.history = h;
    });
  }
}
